import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IResponseWithData } from '../interfaces';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  PLANNER_STATUS,
  PlannerCheckExisting,
  PlannerItem,
  PlannerPayload,
  PlannerUpdateStatusPayload,
  PlannerUpsertPayload,
  ToggleArchivePlannersPayload,
} from '../components/layout/stacked-sidebar/components/planner-v2/planner-v2.interface';

@Injectable({
  providedIn: 'root',
})
export class PlannerService {
  constructor(
    private readonly http: HttpClient,
  ) {
  }

  getExistingPlannersBySearch(body: PlannerCheckExisting): Observable<PlannerItem[]> {
    return this.http.post<IResponseWithData<PlannerItem[]>>(
      `${environment.baseURL}/planner/existing/search`,
      body,
    ).pipe(map(res => res.data));
  }

  upsertPlanners(payload: PlannerUpsertPayload): Observable<void> {
    return this.http.put<IResponseWithData<void>>(
      `${environment.baseURL}/planner/`,
      payload,
    ).pipe(map(v => v.data));
  }

  updatePlannersStatus(plannerIds: string[], status: PLANNER_STATUS): Observable<void> {
    return this.http.put<IResponseWithData<void>>(
      `${environment.baseURL}/planner/status`,
      {
        planner_ids: plannerIds,
        status,
      } as PlannerUpdateStatusPayload,
    ).pipe(map(v => v.data));
  }

  toggleArchivePlanners(plannerIds: string[], active: boolean): Observable<void> {
    return this.http.put<IResponseWithData<void>>(
      `${environment.baseURL}/planner/archive`,
      {
        planner_ids: plannerIds,
        active,
      } as ToggleArchivePlannersPayload,
    ).pipe(map(v => v.data));
  }

  updatePlannerPayload(plannerId: string, payload: Partial<PlannerPayload>): Observable<void> {
    return this.http.put<IResponseWithData<void>>(
      `${environment.baseURL}/planner/payload/${plannerId}/`,
      payload,
    ).pipe(map(v => v.data));
  }

  runPlanners(plannerIds: string[]): Observable<void> {
    return this.http.put<IResponseWithData<void>>(
      `${environment.baseURL}/planner/run/`,
      {
        planner_ids: plannerIds,
      }
    ).pipe(map(v => v.data));
  }

  cancelPlanners(plannerIds: string[]): Observable<void> {
    return this.http.put<IResponseWithData<void>>(
      `${environment.baseURL}/planner/cancel/`,
      {
        planner_ids: plannerIds,
      }
    ).pipe(map(v => v.data));
  }
}
